/// <reference types="office-js" />
/* eslint-disable @typescript-eslint/no-explicit-any */

export async function tryOfficeAsync<T>(
  officeMethod: (
    arg: any,
    callback: (asyncResult: Office.AsyncResult<T>) => void,
  ) => void,
  mapOnlyFirstArg = false,
  ...args: any[]
): Promise<T | null> {
  return new Promise<T | null>((resolve) => {
    const methodArgs = mapOnlyFirstArg ? args[0] : args;
    officeMethod(methodArgs, (asyncResult: Office.AsyncResult<T>) => {
      if (asyncResult.status === Office.AsyncResultStatus.Succeeded) {
        resolve(asyncResult.value ?? null);
      } else {
        console.error('Office async call failed', asyncResult.error);
        resolve(null);
      }
    });
  });
}

export async function tryOfficeWithFallbackAsync<T>(
  officeMethod: (
    arg: any,
    callback: (asyncResult: Office.AsyncResult<T>) => void,
  ) => void,
  officeMethodAlternative: (
    arg: any,
    callback: (asyncResult: Office.AsyncResult<T>) => void,
  ) => void,
  mapOnlyFirstArg = false,
  ...args: any[]
): Promise<T | null> {
  return new Promise<T | null>((resolve) => {
    const methodArgs = mapOnlyFirstArg ? args[0] : args;
    officeMethod(methodArgs, (asyncResult: Office.AsyncResult<T>) => {
      if (asyncResult.status === Office.AsyncResultStatus.Succeeded) {
        resolve(asyncResult.value);
      } else {
        officeMethodAlternative(
          methodArgs,
          (asyncResultAlternative: Office.AsyncResult<T>) => {
            if (
              asyncResultAlternative.status ===
              Office.AsyncResultStatus.Succeeded
            ) {
              resolve(asyncResultAlternative.value);
            } else {
              console.error(
                'Office async call failed',
                asyncResultAlternative.error,
              );
              resolve(null);
            }
          },
        );
      }
    });
  });
}

export async function officeAsyncOrThrow<T>(
  officeMethod: (
    arg: any,
    callback: (asyncResult: Office.AsyncResult<T>) => void,
  ) => void,
  mapOnlyFirstArg = false,
  ...args: any[]
): Promise<T | null> {
  return new Promise<T | null>((resolve, reject) => {
    const methodArgs = mapOnlyFirstArg ? args[0] : args;
    officeMethod(methodArgs, (asyncResult: Office.AsyncResult<T>) => {
      if (asyncResult.status === Office.AsyncResultStatus.Succeeded) {
        resolve(asyncResult.value ?? null);
      } else {
        const officeError = asyncResult.error;
        reject(
          new Error(
            `Office ${officeError?.name ?? 'Error'} (${officeError?.code ?? 'unknown'}): ${officeError?.message ?? 'async call failed'}`,
          ),
        );
      }
    });
  });
}
